var AngleUnit_1;
import { __decorate } from "tslib";
import { Unit } from './Unit';
import { SerializableObject } from '../../data/decorators';
/**
 * @category Unit
 */
let AngleUnit = AngleUnit_1 = class AngleUnit extends Unit {};
AngleUnit.RADIAN = new AngleUnit_1('radian', {
  baseName: 'angle',
  aliases: ['rad', 'rads', 'radians']
});
AngleUnit.DEGREE = new AngleUnit_1('degree', {
  baseName: 'angle',
  aliases: ['deg', 'degs', 'degrees'],
  definitions: [{
    magnitude: Math.PI / 180,
    unit: 'rad'
  }]
});
AngleUnit = AngleUnit_1 = __decorate([SerializableObject()], AngleUnit);
export { AngleUnit };